var _classCallCheck = require("/home/swain/workspace/github/simplealgo/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/home/swain/workspace/github/simplealgo/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/home/swain/workspace/github/simplealgo/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/home/swain/workspace/github/simplealgo/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _get = require("/home/swain/workspace/github/simplealgo/node_modules/@babel/runtime/helpers/get");

var _inherits = require("/home/swain/workspace/github/simplealgo/node_modules/@babel/runtime/helpers/inherits");

var nacl = require('./nacl/naclWrappers');

var address = require('./encoding/address');

var encoding = require('./encoding/encoding');

var txnBuilder = require('./transaction');
/**
 Utilities for manipulating multisig transaction blobs.
 */


var ERROR_MULTISIG_MERGE_LESSTHANTWO = new Error("Not enough multisig transactions to merge. Need at least two");
var ERROR_MULTISIG_MERGE_MISMATCH = new Error("Cannot merge txs. txIDs differ");
var ERROR_MULTISIG_MERGE_WRONG_PREIMAGE = new Error("Cannot merge txs. Multisig preimages differ");
var ERROR_MULTISIG_MERGE_SIG_MISMATCH = new Error("Cannot merge txs. subsigs are mismatched.");
var ERROR_MULTISIG_BAD_FROM_FIELD = new Error("The transaction from field and multisig preimage do not match.");
var ERROR_MULTISIG_KEY_NOT_EXIST = new Error("Key does not exist");
/**
 * MultisigTransaction is a Transaction that also supports creating partially-signed multisig transactions.
 */

var MultisigTransaction =
/*#__PURE__*/
function (_txnBuilder$Transacti) {
  "use strict";

  _inherits(MultisigTransaction, _txnBuilder$Transacti);

  function MultisigTransaction() {
    _classCallCheck(this, MultisigTransaction);

    return _possibleConstructorReturn(this, _getPrototypeOf(MultisigTransaction).apply(this, arguments));
  }

  _createClass(MultisigTransaction, [{
    key: "get_obj_for_encoding",
    value: function get_obj_for_encoding() {
      if (this.hasOwnProperty("objForEncoding")) {
        // if set, use the value for encoding. This allows us to sign existing non-payment type transactions.
        return this.objForEncoding;
      }

      return _get(_getPrototypeOf(MultisigTransaction.prototype), "get_obj_for_encoding", this).call(this);
    }
  }, {
    key: "partialSignTxn",

    /**
     * partialSignTxn partially signs this transaction and returns a partially-signed multisig transaction,
     * encoded with msgpack as a typed array.
     * @param version multisig version
     * @param threshold multisig threshold
     * @param pks multisig public key list, order is important.
     * @param sk an Algorand secret key to sign with.
     * @returns an encoded, partially signed multisig transaction.
     */
    value: function partialSignTxn(_ref, sk) {
      var version = _ref.version,
          threshold = _ref.threshold,
          pks = _ref.pks;

      // verify one more time that the from field is correct
      if (!this.hasOwnProperty("objForEncoding")) {
        var expectedFromRaw = address.fromMultisigPreImg({
          version: version,
          threshold: threshold,
          pks: pks
        });

        if (address.encode(this.from.publicKey) !== address.encode(expectedFromRaw)) {
          throw ERROR_MULTISIG_BAD_FROM_FIELD;
        }
      } // get signature verifier


      var myPk = nacl.keyPairFromSecretKey(sk).publicKey;
      return createMultisigTransaction(this.get_obj_for_encoding(), {
        "rawSig": this.rawSignTxn(sk),
        myPk: myPk
      }, {
        version: version,
        threshold: threshold,
        pks: pks
      });
    }
  }], [{
    key: "from_obj_for_encoding",
    value: function from_obj_for_encoding(txnForEnc) {
      if (txnForEnc.type !== "pay") {
        // we don't support decoding this txn yet - but we can keep signing it since we have the
        // encoded format. We trust that the caller knows what they are trying to sign.
        var txn = Object.create(this.prototype);
        txn.name = "Transaction";
        txn.tag = Buffer.from([84, 88]); // "TX"

        txn.objForEncoding = txnForEnc;
        return txn;
      }

      return _get(_getPrototypeOf(MultisigTransaction), "from_obj_for_encoding", this).call(this, txnForEnc);
    }
  }]);

  return MultisigTransaction;
}(txnBuilder.Transaction);
/**
 * createMultisigTransaction creates a multisig transaction blob.
 * @param txnForEncoding the actual transaction to sign.
 * @param rawSig a Buffer raw signature of that transaction
 * @param myPk a public key that corresponds with rawSig
 * @param version multisig version
 * @param threshold mutlisig threshold
 * @param pks ordered list of public keys in this multisig
 * @returns encoded multisig blob
 */


function createMultisigTransaction(txnForEncoding, _ref2, _ref3) {
  var rawSig = _ref2.rawSig,
      myPk = _ref2.myPk;
  var version = _ref3.version,
      threshold = _ref3.threshold,
      pks = _ref3.pks;
  var keyExist = false; // construct the appendable multisigned transaction format

  var subsigs = pks.map(function (pk) {
    if (nacl.bytesEqual(pk, myPk)) {
      keyExist = true;
      return {
        "pk": Buffer.from(pk),
        "s": rawSig
      };
    }

    return {
      "pk": Buffer.from(pk)
    };
  });

  if (keyExist === false) {
    throw ERROR_MULTISIG_KEY_NOT_EXIST;
  }

  var msig = {
    "v": version,
    "thr": threshold,
    "subsig": subsigs
  };
  var sTxn = {
    "msig": msig,
    "txn": txnForEncoding
  };
  return new Uint8Array(encoding.encode(sTxn));
}
/**
 * mergeMultisigTransactions takes a list of multisig transaction blobs, and merges them.
 * @param multisigTxnBlobs a list of blobs representing encoded multisig txns
 * @returns typed array msg-pack encoded multisig txn
 */


function mergeMultisigTransactions(multisigTxnBlobs) {
  if (multisigTxnBlobs.length < 2) {
    throw ERROR_MULTISIG_MERGE_LESSTHANTWO;
  }

  var refSigTx = encoding.decode(multisigTxnBlobs[0]);
  var refSigAlgoTx = MultisigTransaction.from_obj_for_encoding(refSigTx.txn);
  var refTxIDStr = refSigAlgoTx.txID().toString();
  var from = address.encode(refSigTx.txn.snd);
  var newSubsigs = refSigTx.msig.subsig;

  for (var i = 0; i < multisigTxnBlobs.length; i++) {
    var unisig = encoding.decode(multisigTxnBlobs[i]);
    var unisigAlgoTxn = MultisigTransaction.from_obj_for_encoding(unisig.txn);

    if (unisigAlgoTxn.txID().toString() !== refTxIDStr) {
      throw ERROR_MULTISIG_MERGE_MISMATCH;
    } // check multisig has same preimage as reference


    if (unisig.msig.subsig.length !== refSigTx.msig.subsig.length) {
      throw ERROR_MULTISIG_MERGE_WRONG_PREIMAGE;
    }

    var preimg = {
      "version": unisig.msig.v,
      "threshold": unisig.msig.thr,
      "pks": unisig.msig.subsig.map(function (subsig) {
        return subsig.pk;
      })
    };

    if (from !== address.encode(address.fromMultisigPreImg(preimg))) {
      throw ERROR_MULTISIG_MERGE_WRONG_PREIMAGE;
    } // now, we can merge


    newSubsigs = unisig.msig.subsig.map(function (uniSubsig, index) {
      var current = newSubsigs[index];

      if (current.s) {
        if (uniSubsig.s && Buffer.compare(uniSubsig.s, current.s) !== 0) {
          // mismatch
          throw ERROR_MULTISIG_MERGE_SIG_MISMATCH;
        }

        return {
          "pk": current.pk,
          "s": current.s
        };
      } else if (uniSubsig.s) {
        return {
          "pk": current.pk,
          "s": uniSubsig.s
        };
      }

      return current;
    });
  }

  var msig = {
    "v": refSigTx.msig.v,
    "thr": refSigTx.msig.thr,
    "subsig": newSubsigs
  };
  var sTxn = {
    "msig": msig,
    "txn": refSigTx.txn
  };
  return new Uint8Array(encoding.encode(sTxn));
}

module.exports = {
  MultisigTransaction: MultisigTransaction,
  mergeMultisigTransactions: mergeMultisigTransactions,
  createMultisigTransaction: createMultisigTransaction,
  ERROR_MULTISIG_MERGE_LESSTHANTWO: ERROR_MULTISIG_MERGE_LESSTHANTWO,
  ERROR_MULTISIG_MERGE_MISMATCH: ERROR_MULTISIG_MERGE_MISMATCH,
  ERROR_MULTISIG_MERGE_WRONG_PREIMAGE: ERROR_MULTISIG_MERGE_WRONG_PREIMAGE,
  ERROR_MULTISIG_MERGE_SIG_MISMATCH: ERROR_MULTISIG_MERGE_SIG_MISMATCH
};